exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card-subtitle {\n  font-size: 20px;\n  padding-top: 20px;\n  padding-bottom: 19px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/homescreen/homescreen.component.scss
// module id = ../../../../../src/app/agatextscreens/homescreen/homescreen.component.scss
// module chunks = 0